/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CatalogAssetResponseDto,
  CatalogAssetUpdateRequestDto,
  CatalogResponseDto,
  CatalogResponseDtoPageResponseDto,
  CatalogUploadResponseDto,
  CategoryCreateRequestDto,
  CategoryResponseDto,
  CategoryUpdateRequestDto,
  EntityType,
  ProblemDetails,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Catalogs<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description This endpoint retrieves a list of all available categories. (Requires authentication)
   *
   * @tags Catalogs
   * @name CategoriesList
   * @summary Get All Categories
   * @request GET:/catalogs/categories
   * @secure
   */
  categoriesList = (params: RequestParams = {}) =>
    this.request<CategoryResponseDto[], ProblemDetails | void>({
      path: `/catalogs/categories`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint inserts a new category. (Admin and Super Admin gated endpoint)
   *
   * @tags Catalogs
   * @name CategoriesCreate
   * @summary Insert a New Category
   * @request POST:/catalogs/categories
   * @secure
   */
  categoriesCreate = (
    data: CategoryCreateRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<CategoryResponseDto, ProblemDetails | void>({
      path: `/catalogs/categories`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint retrieves a specific category by its ID. (Requires authentication)
   *
   * @tags Catalogs
   * @name CategoriesDetail
   * @summary Get Category by ID
   * @request GET:/catalogs/categories/{categoryId}
   * @secure
   */
  categoriesDetail = (categoryId: string, params: RequestParams = {}) =>
    this.request<CategoryResponseDto, ProblemDetails | void>({
      path: `/catalogs/categories/${categoryId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint deletes a category by its ID. (Admin and Super Admin gated endpoint)
   *
   * @tags Catalogs
   * @name CategoriesDelete
   * @summary Delete Category by ID
   * @request DELETE:/catalogs/categories/{categoryId}
   * @secure
   */
  categoriesDelete = (categoryId: string, params: RequestParams = {}) =>
    this.request<void, ProblemDetails | void>({
      path: `/catalogs/categories/${categoryId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description This endpoint updates an existing category. (Admin and Super Admin gated endpoint)
   *
   * @tags Catalogs
   * @name CategoriesPartialUpdate
   * @summary Update an Existing Category
   * @request PATCH:/catalogs/categories/{categoryId}
   * @secure
   */
  categoriesPartialUpdate = (
    categoryId: string,
    data: CategoryUpdateRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<CategoryResponseDto, ProblemDetails | void>({
      path: `/catalogs/categories/${categoryId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint retrieves all packs. (Open to authenticated users)
   *
   * @tags Catalogs
   * @name PacksList
   * @summary Get All Packs
   * @request GET:/catalogs/packs
   * @secure
   */
  packsList = (params: RequestParams = {}) =>
    this.request<CatalogResponseDto[], ProblemDetails | void>({
      path: `/catalogs/packs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint creates a new Pack and associates it with categories. (Admin or Super Admin gated)
   *
   * @tags Catalogs
   * @name PacksCreate
   * @summary Creates a new Pack
   * @request POST:/catalogs/packs
   * @secure
   */
  packsCreate = (
    data: {
      Name?: string;
      Description?: string;
      CategoryIds?: string[];
      IsDefault?: boolean;
      /** @format binary */
      File?: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<CatalogResponseDto, ProblemDetails | void>({
      path: `/catalogs/packs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint retrieves packs with pagination. (Open to authenticated users)
   *
   * @tags Catalogs
   * @name PacksPagedList
   * @summary Get Paginated Packs
   * @request GET:/catalogs/packs/paged
   * @secure
   */
  packsPagedList = (
    query?: {
      /** @format int32 */
      CurrentPage?: number;
      /** @format int32 */
      PageSize?: number;
      Filters?: Record<string, string>;
      Sorts?: Record<string, string>;
    },
    params: RequestParams = {},
  ) =>
    this.request<CatalogResponseDtoPageResponseDto, ProblemDetails | void>({
      path: `/catalogs/packs/paged`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint retrieves all Packs for a specific category. (Open to authenticated users)
   *
   * @tags Catalogs
   * @name CategoriesPacksList
   * @summary Get Packs by Category
   * @request GET:/catalogs/categories/{categoryId}/packs
   * @secure
   */
  categoriesPacksList = (categoryId: string, params: RequestParams = {}) =>
    this.request<CatalogResponseDto[], ProblemDetails | void>({
      path: `/catalogs/categories/${categoryId}/packs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint updates an existing Pack, including its name, categories, and icon. (Admin or Super Admin gated)
   *
   * @tags Catalogs
   * @name PacksPartialUpdate
   * @summary Update an existing Pack
   * @request PATCH:/catalogs/packs/{packId}
   * @secure
   */
  packsPartialUpdate = (
    packId: string,
    data: {
      Name?: string;
      Description?: string;
      CategoryIds?: string[];
      IsDefault?: boolean;
      /** @format binary */
      File?: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<CatalogResponseDto, ProblemDetails | void>({
      path: `/catalogs/packs/${packId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint retrieves the details of a specific Pack by its ID, including assets and categories associated with the catalog. (Access may be restricted based on user permissions)
   *
   * @tags Catalogs
   * @name PacksDetail
   * @summary Get Pack by ID
   * @request GET:/catalogs/packs/{packId}
   * @secure
   */
  packsDetail = (packId: string, params: RequestParams = {}) =>
    this.request<CatalogResponseDto, ProblemDetails | void>({
      path: `/catalogs/packs/${packId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint deletes a Pack and all associated assets, categories, and team links by its ID. It also handles blob cleanup in Azure storage. (Admin or Super Admin gated)
   *
   * @tags Catalogs
   * @name PacksDelete
   * @summary Delete a Pack by ID
   * @request DELETE:/catalogs/packs/{packId}
   * @secure
   */
  packsDelete = (packId: string, params: RequestParams = {}) =>
    this.request<void, ProblemDetails | void>({
      path: `/catalogs/packs/${packId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description This endpoint retrieves the details of a specific catalog asset by its ID, including the associated user and user account info. (Access is open for authenticated users)
   *
   * @tags Catalogs
   * @name AssetsDetail
   * @summary Get Catalog Asset by ID
   * @request GET:/catalogs/assets/{assetId}
   * @secure
   */
  assetsDetail = (assetId: string, params: RequestParams = {}) =>
    this.request<CatalogAssetResponseDto, ProblemDetails | void>({
      path: `/catalogs/assets/${assetId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint updates a specific catalog asset by its ID with the provided changes. Only Admin or Super Admin roles are authorized to perform this operation. (Admin or Super Admin gated)
   *
   * @tags Catalogs
   * @name AssetsPartialUpdate
   * @summary Update a Catalog Asset by ID
   * @request PATCH:/catalogs/assets/{assetId}
   * @secure
   */
  assetsPartialUpdate = (
    assetId: string,
    data: CatalogAssetUpdateRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<CatalogAssetResponseDto, ProblemDetails | void>({
      path: `/catalogs/assets/${assetId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint deletes a catalog asset by its ID, including associated files in Azure Blob Storage. (Admin or Super Admin gated)
   *
   * @tags Catalogs
   * @name AssetsDelete
   * @summary Delete Catalog Asset by ID
   * @request DELETE:/catalogs/assets/{assetId}
   * @secure
   */
  assetsDelete = (assetId: string, params: RequestParams = {}) =>
    this.request<void, ProblemDetails | void>({
      path: `/catalogs/assets/${assetId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Uploads a new catalog asset to Azure Blob Storage along with optional thumbnail and metadata. Requires Admin or Super Admin access. (Admin or Super Admin gated)
   *
   * @tags Catalogs
   * @name AssetsCreate
   * @summary Create a new Catalog Asset
   * @request POST:/catalogs/assets
   * @secure
   */
  assetsCreate = (
    data: {
      /** @format uuid */
      CatalogId: string;
      /** @format uuid */
      TeamId: string;
      /** @format binary */
      File: File;
      /** @format binary */
      Thumbnail?: File;
      Title: string;
      Metadata?: any;
      EntityType?: EntityType;
    },
    params: RequestParams = {},
  ) =>
    this.request<CatalogUploadResponseDto, ProblemDetails | void>({
      path: `/catalogs/assets`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new catalog pack by copying all assets from the specified folder and optionally uploading a new thumbnail image. Requires valid categories and authenticated user access.
   *
   * @tags Catalogs
   * @name CreatePackFromFolderCreate
   * @summary Create a new Catalog Pack from existing Folder
   * @request POST:/catalogs/create-pack-from-folder/{folderId}
   * @secure
   */
  createPackFromFolderCreate = (
    folderId: string,
    data: {
      Name?: string;
      Description?: string;
      CategoryIds?: string[];
      /** @format binary */
      File?: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/catalogs/create-pack-from-folder/${folderId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
}
